// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groupTitle[data-v-d64fde36]{line-height:40px;font-size:16px;padding-left:20px;margin-bottom:1em;background:#f0f0f0}", ""]);
// Exports
module.exports = exports;
